import { render, staticRenderFns } from "./ProjectConfigurationBackground.vue?vue&type=template&id=ba324722&"
import script from "./ProjectConfigurationBackground.vue?vue&type=script&lang=js&"
export * from "./ProjectConfigurationBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports